/**
 * The y of a drawn polyline at pixel [x], straight between the points either side —
 * for marking a position on an elevation chart's line. Null outside the line.
 * [points] are in drawing order (x rising), as Chart.js lays out a line dataset.
 */
export function lineYAt(points: { x: number; y: number }[], x: number): number | null {
  if (points.length < 2 || x < points[0].x - 0.5 || x > points[points.length - 1].x + 0.5) return null;
  for (let i = 1; i < points.length; i += 1) {
    const a = points[i - 1];
    const b = points[i];
    if (x <= b.x) return b.x === a.x ? b.y : a.y + ((x - a.x) / (b.x - a.x)) * (b.y - a.y);
  }
  return points[points.length - 1].y;
}
